module.exports = __webpack_public_path__ + "img/teddy_bear.549dadaa.gif";